import { useEffect, useState } from 'react';
import loading from 'assets/lottie/loading.json';
import Lottie from 'lottie-react';
import styles from './loading-screen.module.scss';

const LoadingScreen: React.FC = () => {
  const [uploadPercentage, setUploadPercentage] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setUploadPercentage((prev) => {
        const next = prev + 2;
        if (next > 100) {
          return 0;
        }
        return next;
      });
    }, 100);
    return () => clearInterval(interval);
  }, []);

  const showProgressBar = () => (
    <div className={styles.loadingBar}>
      <div
        className={styles.progress}
        style={{ width: `${uploadPercentage}%` }}
      />
    </div>
  );

  return (
    <div className={styles.container}>
      <Lottie animationData={loading} />
      <span className="text__heading3__gray800">
        Building your personalized topics...
      </span>
      {showProgressBar()}
      <div className={styles.containerText}>
        <span className="text__body__regular__large__gray700">
          Topics guide your storytelling journey —
        </span>
        <span className="text__body__regular__large__gray700">
          Think of them as gentle nudges to help your story unfold.
        </span>
      </div>
    </div>
  );
};

export { LoadingScreen };
